<div [class.expanded]="expanded"><span></span><span></span></div>
